import React from "react";
import { Form, InputGroup } from "react-bootstrap";

const InputField = ({
  type = "",
  className = "",
  placeholder = "",
  value = "",
  onChange = () => {},
  disabled = false,
  name = "",
  errors,
  icon,
  onIconClick = () => {},
}) => {
  return (
    <>
      <div>
        <InputGroup>
          <Form.Control
            aria-describedby="passwordHelpBlock"
            placeholder={placeholder}
            variant="outlined"
            type={type}
            className={`inputfield ${className}`}
            id={name}
            value={value}
            onChange={onChange}
            disabled={disabled}
            name={name}
            autoFocus
          />
          {icon ? (
            <InputGroup.Text id="basic-addon2" onClick={onIconClick}>
              {icon}
            </InputGroup.Text>
          ) : null}
        </InputGroup>
      </div>
      <div className="d-flex">
        <div style={{ color: "red" }}>{errors}</div>
      </div>
    </>
  );
};

export default React.memo(InputField);
